// crm-web/frontend/src/hooks/useAnalyticsRefresh.js
// Auto-refresh del dashboard con pausa cuando la pestaña no esta visible.
// Toma un callback refreshFn + intervalo (default 5 min).

import { useEffect, useRef } from 'react'

const DEFAULT_INTERVAL_MS = 5 * 60 * 1000  // 5 minutos

export default function useAnalyticsRefresh(refreshFn, intervalMs = DEFAULT_INTERVAL_MS) {
  // Ref para evitar que cambios en refreshFn reinicien el interval
  const refreshFnRef = useRef(refreshFn)
  refreshFnRef.current = refreshFn

  useEffect(() => {
    let intervalId = null

    function startInterval() {
      if (intervalId != null) return
      intervalId = setInterval(() => {
        // Llamada via ref para tomar la version mas reciente de refreshFn
        refreshFnRef.current()
      }, intervalMs)
    }

    function stopInterval() {
      if (intervalId != null) {
        clearInterval(intervalId)
        intervalId = null
      }
    }

    function handleVisibility() {
      if (document.visibilityState === 'hidden') {
        stopInterval()
      } else {
        startInterval()
      }
    }

    // Arranca si visible
    if (document.visibilityState === 'visible') {
      startInterval()
    }

    document.addEventListener('visibilitychange', handleVisibility)
    return () => {
      stopInterval()
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [intervalMs])
}
